import React from 'react'
import { Meta, User, /* ButtonBookmark, ButtonLike */ } from '../../../components'
import colors from '../../../utils/colors'

// const ActionButtons = ({className, mobile}) => {
//   const [bookmarked, setBookmarked] = React.useState(false)
//   const [liked, setLiked] = React.useState(false)

//   const handleBookmark = () => {
//     setBookmarked(!bookmarked)
//   }

//   const handleLike = () => {
//     setLiked(!liked)
//   }

//   return (
//     <div className={`${className}`}>
//       <ButtonBookmark transparent thin={true} className="mb-5" onClick={handleBookmark} active={bookmarked}/>
//       <ButtonLike transparent thin={true} className="mb-2" onClick={handleLike} active={liked}/>
//       <p className="text-xs text-gray-444 text-center">Liked by 1,312</p>
//     </div>
//   )
// }

const Sidebar = ({data}) => {
  return (
    <div className="w-full">
      <div className="flex flex-wrap lg:block">
        {/* <div className="w-full order-2 lg:order-1">
          <ActionButtons />
          <hr className="my-5 lg:my-10"/>
        </div> */}
        <div className="order-1 w-full lg:order-2">
          {/* <div className="hidden lg:block mb-8 lg:w-auto">
            <User />
          </div> */}
          <div className="flex flex-wrap -mx-2 lg:mx-0 lg:block">
            <div className="w-1/2 lg:w-auto px-2 lg:px-0 mb-4 lg:mb-8">
              <Meta
                label="Category"
                value={data.categories}
              />
            </div>
            <div className="w-1/2 lg:w-auto px-2 lg:px-0 mb-4 lg:mb-8">
              <Meta
                label="Approach"
                value={data.approach}
              />
            </div>
            <div className="w-1/2 lg:w-auto px-2 lg:px-0 mb-4 lg:mb-8">
              <Meta
                label="Issues"
                value={data.issues}
              />
            </div>
            {/* <div className="w-1/2 lg:w-auto px-2 lg:px-0 mb-6 lg:mb-0">
              <Meta
                label="Suitable for"
                value="Educator, Donor, Professionals"
              />
            </div> */}
          </div>
          <hr className="hidden lg:block my-5 lg:my-10"/>
          <div className="w-full lg:hidden">
            <User name={data.organization}/>
            <hr className="my-6"/>
          </div>
        </div>
      </div>
      <div className="mb-5">
        <p className="text-sm lg:text-xs font-bold mb-5 text-center lg:text-left mt-2 lg:mt-0">Share this blog</p>
        <div className="flex items-center justify-center lg:justify-start -mx-2">
          <div className="w-1/4 lg:w-1/3 px-2">
            <div
              className="rounded border text-primary text-xs text-center px-2 py-1 cursor-pointer"
              style={{borderColor: colors.primary}}
            >
              Copy
            </div>
          </div>
          <div className="w-auto lg:w-1/3 px-2">
            <div className="flex items-center">
              <img className="mr-2 cursor-pointer" src="/images/logos/khub_facebook-logo.svg" alt="facebook"/>
              <img className="mr-2 cursor-pointer" src="/images/logos/khub_twitter.svg" alt="twitter"/>
              <img className="lg:mr-2 cursor-pointer" src="/images/logos/khub_linkedin.svg" alt="linkedin"/>
            </div>
          </div>
        </div>
      </div>
      <hr className="my-8 lg:hidden"/>
    </div>
  )
}

export { Sidebar }